import { render, staticRenderFns } from "./projectPropertiesTable.vue?vue&type=template&id=371efc0a"
import script from "./projectPropertiesTable.vue?vue&type=script&lang=js"
export * from "./projectPropertiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports